/**
 * Runs a JavaScript `source` code with global variables from `context` in an
 * isolated environment. Similar to `vm.runInNewContext()` in Node.js.
 * @param context - Execution context (global variables to inject to sandbox).
 * @returns Result of `source` if it's an expression (`undefined` otherwise).
 */
const vm = document.createElement('iframe');
vm.style.display = 'none';
document.body.appendChild(vm);
const contentWindow = vm.contentWindow as any;

const runInSandbox = (source: string, context: Record<string, any>): any => {
  const keys = Object.keys(context);
  for (const key of keys) {
    contentWindow[key] = context[key];
  }

  const result = contentWindow.eval(source);

  for (const key of keys) {
    delete contentWindow[key];
  }

  return result;
};

export default runInSandbox;
